module.exports = __webpack_public_path__ + "static/media/pic2_Isheni2.073c8272.jpg";